module.exports = __webpack_public_path__ + "static/media/sabotage1.85bd8f57.png";